export default [
  // {
  //   title: 'Charts',
  //   icon: 'PieChartIcon',
  //   tag: '3',
  //   tagVariant: 'light-danger',
  //   children: [
  //     {
  //       title: 'Apex Chart',
  //       route: 'charts-apex-chart',
  //     },
  //     {
  //       title: 'Chartjs',
  //       route: 'charts-chartjs',
  //     },
  //     {
  //       title: 'Echart',
  //       route: 'charts-echart',
  //     },
  //   ],
  // },
  // {
  //   title: 'Leaflet',
  //   route: 'maps-leaflet',
  //   icon: 'MapIcon',
  // },
  {
    title: 'ทช. ส่วนกลาง',
    icon: 'PieChartIcon',
    children: [
      {
        Link: 'link?deptid=0&typename=Lighting',
        title: 'Lighting',
      },
      {
        Link: 'link?deptid=0&typename=Counting',
        title: 'Counting',
      },
      {
        Link: 'link?deptid=0&typename=CCTV',
        title: 'CCTV',
      },
      {
        Link: 'link?deptid=0&typename=Bridge',
        title: 'Bridge',
      },
      {
        Link: 'link?deptid=0&typename=Analytic',
        title: 'Analytic',
      },
      {
        Link: 'link?deptid=0&typename=Motion',
        title: 'Motion',
      },
      {
        Link: 'link?deptid=0&typename=SCADA',
        title: 'SCADA',
      },
      {
        Link: 'link?deptid=0&typename=Tunnel',
        title: 'Tunnel',
      },
      {
        Link: 'link?deptid=0&typename=TrafficSign',
        title: 'TrafficSign',
      },
      {
        Link: 'link?deptid=0&typename=Traffic',
        title: 'Traffic',
      },
    ],
  },
]
